/**
 * v6.37.14 — Rep Playbook (Sales Team Training & Call Playbook).
 *
 * Wraps the existing PresentationPlaybook component so sales reps can
 * access the full 3-part playbook (30-Min Demo Script + Audience Guides
 * + Part III Sales Team Training) directly from their /demo-launcher
 * home. Previously the playbook was only rendered inside the Super
 * Admin Dashboard, invisible to reps.
 *
 * Available to: sales_rep_universal, super_admin (via AppRouter guard).
 */
import React, { useContext } from "react";
import { useNavigate } from "react-router-dom";
import { ArrowLeft, BookOpen } from "lucide-react";
import { Button } from "@/components/ui/button";
import PresentationPlaybook from "@/components/PresentationPlaybook";
import AuthContext from "@/contexts/AuthContext";

const RepPlaybook = () => {
  const navigate = useNavigate();
  const { user } = useContext(AuthContext);
  const backTarget =
    user?.role === "super_admin" ? "/superadmin" : "/demo-launcher";

  return (
    <div className="min-h-screen bg-gray-50" data-testid="rep-playbook-page">
      <div className="max-w-6xl mx-auto px-6 py-8">
        <div className="mb-6 flex items-center justify-between">
          <div className="flex items-center gap-3">
            <div className="w-11 h-11 bg-[#002FA7]/10 flex items-center justify-center">
              <BookOpen size={22} className="text-[#002FA7]" />
            </div>
            <div>
              <div className="text-[11px] font-bold tracking-widest text-gray-500">
                REP PORTAL
              </div>
              <h1
                className="text-2xl font-bold text-gray-900"
                style={{ fontFamily: "Outfit, sans-serif" }}
              >
                Sales Team Training & Call Playbook
              </h1>
              <p className="text-sm text-gray-500 mt-0.5">
                Qualify, present, handle objections, and close — all in one
                place.
              </p>
            </div>
          </div>
          <Button
            variant="outline"
            onClick={() => navigate(backTarget)}
            className="btn-sharp"
            data-testid="rep-playbook-back-btn"
          >
            <ArrowLeft size={14} className="mr-1.5" />
            Back
          </Button>
        </div>

        <PresentationPlaybook />
      </div>
    </div>
  );
};

export default RepPlaybook;
